import { textColumn } from '@/shared/grids/columns/textColumn';
import { GridColumnExtraSettings, GridColumnSettings } from '@/shared/types/grid';

export const organisationLinkColumn = <T>(options: {
  uid?: string;
  idField: keyof T & string;
  nameField: keyof T & string;
  header: string;
  width?: number;
  extra?: GridColumnExtraSettings<T>;
}): GridColumnSettings<T> => {
  const { uid, idField, nameField, header, width, extra } = options;

  return textColumn({
    uid,
    field: idField,
    header,
    width,
    template: `\${if(${idField} && ${nameField})}<a href="/organisations/\${${idField}}" class="grid-link" data-offcanvas="true">\${${nameField}}</a>\${else}<span class="text-more-muted">Not set</span>\${/if}`,
    extra: {
      displayField: nameField,
      ...extra,
    },
  });
};
